<template>
  <BaseDialog
    v-model="showDialog"
    dialogIcon="mdi-account-edit"
    title="Profil"
    subtitle="Oppdater profil"
    btnActionName="Lagre"
    @action="save"
  >
    <template v-slot>
      <v-form
        v-if="profileData && contactPersonData"
        ref="form"
        v-model="valid"
      >
        <v-text-field
          v-model="profileData.title"
          class="textFieldError"
          prepend-inner-icon="mdi-account-hard-hat"
          color="primary"
          label="Tittel"
          filled
          autocomplete="organization-title"
        ></v-text-field>
        <v-text-field
          v-model="profileData.mobile"
          class="textFieldError"
          prepend-inner-icon="mdi-cellphone"
          color="primary"
          label="Mobil*"
          filled
          :rules="[(v) => !!v || 'Mobil må fylles ut!']"
          required
          autocomplete="tel"
          pattern="[0-9]*"
        ></v-text-field>

        <BirthdayPicker v-model="profileData.birthDate" label="Fødselsdato" />

        <v-text-field
          v-model="contactPersonData.hmsCardNumber"
          class="mt-5 textFieldError"
          prepend-inner-icon="mdi-card-account-details-outline"
          color="primary"
          label="HMS kortnummer"
          filled
          pattern="[0-9]*"
        ></v-text-field>

        <BirthdayPicker
          v-model="contactPersonData.hmsCardIssuedDate"
          label="HMS Utstedt"
          :min="moment().subtract(2, 'year').format('YYYY-MM-DD')"
        />
      </v-form>
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";
import api from "@/api/api";
import { mapActions } from "vuex";
import moment from "moment";

import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import notification from "@/helpers/notification";
import BirthdayPicker from "@/components/shared/date/BirthdayPicker.vue";

export default Vue.extend({
  name: "EditProfileDialog",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    profile: {
      type: Object,
    },
  },
  data() {
    return {
      valid: false,
      profileData: null,
      contactPersonData: {},
      hmsCardNumber: null,
      hmsCardIssuedDate: null,
      moment,
    };
  },
  methods: {
    ...mapActions({
      updateProfile: "shared/updateProfile",
    }),
    async save() {
      const isValid = (this as any).$refs?.form?.validate();
      if (isValid) {
        var data = { ...this.profile };

        data.person = this.profileData;
        data.hmsCardNumber = (this as any).contactPersonData.hmsCardNumber;
        data.hmsCardIssuedDate = (
          this as any
        ).contactPersonData.hmsCardIssuedDate;

        delete data.contact;
        delete data.contacts;
        await api.putContactPerson(data).then((Response) => {
          this.updateProfile(Response);
          this.showDialog = false;
        });
      } else {
        notification.warn("Alle obligatoriske felter må fylles ut!");
      }
    },
    setData() {
      this.profileData = { ...this.profile.person };
      this.contactPersonData = { ...this.profile };
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        if (this.value) {
          this.setData();
        }
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
    // profileData: {
    //   get(): string {
    //     return this.profile.person;
    //   },
    // },
  },

  components: {
    BaseDialog,
    BirthdayPicker,
  },
});
</script>
